module.exports = __webpack_public_path__ + "img/qr-code-enquiry.32de3eee.svg";